import { useTranslation } from "react-i18next";
import {
  ContactDetailsSectionBreadcrumbs,
  ContactDetailsSectionBreadcrumbsProps,
} from "../ContactDetailsSectionBreadcrumbs";
import { ContactDetailsSections } from "../../../ContactsDialog";
import { TellescopeModelFromName } from "@tellescope/tanstack-query";
import { useMemo, useState } from "react";
import { Plus } from "lucide-react";

export interface ContentSectionProps {
  enduser: TellescopeModelFromName<"endusers">;
}

export const ContentSection = ({ enduser }: ContentSectionProps) => {
  const [showShareContent, setShowShareContent] = useState(false);
  const { t } = useTranslation("contacts");

  const { breadcrumbs, actionButtons } = useMemo<
    Pick<ContactDetailsSectionBreadcrumbsProps, "breadcrumbs" | "actionButtons">
  >(() => {
    const breadcrumbs: ContactDetailsSectionBreadcrumbsProps["breadcrumbs"] = [
      {
        title: t("Content"),
        onClick: showShareContent ? () => setShowShareContent(false) : undefined,
      },
    ];
    if (showShareContent) {
      breadcrumbs.push({ title: t("Share Content") });
    }

    const actionButtons: ContactDetailsSectionBreadcrumbsProps["actionButtons"] = showShareContent
      ? undefined
      : [
          {
            hoverLabel: t("Share Content"),
            onClick: () => setShowShareContent(true),
            icon: Plus,
          },
        ];

    return { breadcrumbs, actionButtons };
  }, [showShareContent, t]);

  return (
    <div className="flex flex-col gap-4 overflow-y-hidden">
      <ContactDetailsSectionBreadcrumbs
        enduserId={enduser.id}
        breadcrumbs={breadcrumbs}
        actionButtons={actionButtons}
      />
      {showShareContent ? (
        <ContactDetailsSections.ShareContentForm contactId={enduser.id} onSubmit={() => setShowShareContent(false)} />
      ) : (
        <ContactDetailsSections.ContentSection contact={enduser} />
      )}
    </div>
  );
};
